module.exports = __webpack_public_path__ + "img/proxy-refund.f3228140.svg";